<template>
	<div style="background: #f5f5f5; min-height: 100vh">
		<brieHeader />
		<crumbs :crumFlag="true" bTxt="返回登录" />
		<div class="regBox">
			<div class="regTit">请选择身份</div>
			<div class="regTip">
				<img src="@/assets/img/jg.svg" alt="" />
				一个手机号仅能注册一种身份账户
			</div>
			<div class="regCont">
				<div class="regItem" @click="regBtn(1)" :class="{ active: regFlag == 1 ? true : false }">
					<img src="@/assets/img/laos.png" alt="" />
					<div class="regRig">
						<h2>我是老师</h2>
						<p>I am a teacher</p>
					</div>
				</div>
				<div class="regItem" @click="regBtn(2)" :class="{ active: regFlag == 2 ? true : false }">
					<img src="@/assets/img/xues.png" alt="" />
					<div class="regRig">
						<h2>我是学生</h2>
						<p>I am a student</p>
					</div>
				</div>
			</div>
		</div>
		<loginFoot />
	</div>
</template>

<script>
import loginFoot from '@/components/foot/loginFoot';
import crumbs from '@/components/hearder/crumbs';
import brieHeader from '@/components/hearder/brieHeader';
export default {
	name: 'regA',
	data() {
		return {
			a: ['返回登录'],
			regFlag: ''
		};
	},
	components: {
		brieHeader,
		loginFoot,
		crumbs
	},
	methods: {
		regBtn(type) {
			this.regFlag = type;
			if (this.regFlag == 1) {
				this.$router.push({
					path: 'regb'
				});
			} else {
				this.$router.push({
					path: 'regC'
				});
			}
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.regBox {
	width: 1200px;
	height: 478px;
	margin: 0 auto 50px;
	background: #fff;
	box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.17);
	border-radius: 6px;
	.regTit {
		text-align: center;
		font-size: 22px;
		color: #000000;
		font-weight: bold;
		padding: 81px 0 23px;
	}
	.regTip {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		color: #fe2109;
		margin-bottom: 59px;
		img {
			width: 20px;
			height: 20px;
			margin-right: 2px;
		}
	}
	.regCont {
		display: flex;
		justify-content: center;
		.regItem {
			width: 410px;
			height: 140px;
			margin-right: 55px;
			cursor: pointer;
			background: #f7f8ff;
			border-radius: 11px;
			display: flex;
			justify-content: center;
			align-items: center;
			&:last-of-type {
				margin-right: 0;
			}
			&:hover {
				background: linear-gradient(184deg, #1ab34a 0%, #1d7b3a 100%);
				box-shadow: 0px 10px 19px 0px #dcf2e3;
				.regRig h2 {
					color: #fff;
				}
				.regRig p {
					color: #fff;
				}
			}
			img {
				width: 67px;
				height: 67px;
				margin-right: 43px;
			}
			.regRig {
				h2 {
					color: #000000;
					font-size: 22px;
					margin-bottom: 10px;
				}
				p {
					font-size: 18px;
					color: #d3d4db;
				}
			}
		}
	}
}
</style>
